import React, { useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { BsPlusCircle } from "react-icons/bs";

const normalize = (value) => (value || "").trim();

const LocationSearchableDropdown = ({
    id,
    value,
    onChange,
    options = [],
    placeholder = "Select location",
    dropUp = false,
}) => {
    const [show, setShow] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const normalizedOptions = useMemo(() => {
        const seen = new Set();
        return options
            .map(normalize)
            .filter((opt) => {
                if (!opt) return false;
                const key = opt.toLowerCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
    }, [options]);

    const filteredOptions = useMemo(() => {
        const term = normalize(searchTerm).toLowerCase();
        if (!term) return normalizedOptions;
        return normalizedOptions.filter((opt) => opt.toLowerCase().includes(term));
    }, [normalizedOptions, searchTerm]);

    const typedValue = normalize(searchTerm);
    const canAddTypedValue =
        typedValue.length > 0 &&
        !normalizedOptions.some((opt) => opt.toLowerCase() === typedValue.toLowerCase());

    const handleSelectExisting = (selected) => {
        onChange(selected);
        setSearchTerm("");
        setShow(false);
    };

    const handleConfirmTyped = () => {
        if (!typedValue) return;
        onChange(typedValue);
        setSearchTerm("");
        setShow(false);
    };


    return (
        <Dropdown show={show} onToggle={setShow} drop={dropUp ? "up" : "down"}>
            <Dropdown.Toggle variant="light" id={id} className="w-100 text-start">
                <span className="d-inline-block text-truncate" style={{ maxWidth: "100%" }}>
                    {normalize(value) || placeholder}
                </span>
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ minWidth: "100%", zIndex: 1055 }}>
                <div
                    className="px-2 py-2"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <div className="d-flex align-items-center">
                        <input
                            type="text"
                            value={searchTerm}
                            placeholder="Add or Search location"
                            className="form-control form-control-sm me-2"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <BsPlusCircle  
                            onClick={!typedValue ? undefined : handleConfirmTyped}
                            title={canAddTypedValue ? "Add typed location" : "Use typed location"}
                            aria-label={canAddTypedValue ? "Add typed location" : "Use typed location"}
                            role="button"
                            style={{ cursor: typedValue ? 'pointer' : 'not-allowed',  }}
                           
                        />
                    </div>
                </div>

                {filteredOptions.map((opt) => (
                    <Dropdown.Item key={opt} onClick={() => handleSelectExisting(opt)}>
                        {opt}
                    </Dropdown.Item>
                ))}

                {filteredOptions.length === 0 && (
                    <div className="px-3 py-2">
                        {typedValue ? "No match, click + to use typed value" : "No locations"}
                    </div>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LocationSearchableDropdown;
